import AttendanceEditComponent from "../components/AttendanceEdit";
import useAttendance from "../hooks/useAttendance";

const AttendanceEdit = () => {
  const AttendanceProps = useAttendance();
  return <AttendanceEditComponent {...AttendanceProps} />;
};

export default AttendanceEdit;
